import {Roles} from "../../helpers/roles";

export const projectRoutes = [
    {
        path: '',
        name: 'adminProjects',
        component: () => import('@/pages/back/registry/projects/ProjectList.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN', Roles.PORTAL_PROJET], // read
        },
    },
    {
        path: 'create',
        name: 'adminProjectCreate',
        component: () => import('@/pages/back/registry/projects/ProjectCreate.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN', Roles.PROJET_CREATE], // create
        },
    },
    {
        path: 'edit/:code',
        name: 'adminProjectEdit',
        component: () => import('@/pages/back/registry/projects/ProjectEdit.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN', Roles.PROJET_EDIT], // update
        },
    },
    {
        path: 'view/:code',
        name: 'adminProjectView',
        component: () => import('@/pages/back/registry/projects/ProjectView.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN', Roles.PROJET_READ], // read
        },
    },
];
